var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "b-row",
    [
      _c(
        "b-col",
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                [
                  _c(
                    "b-button",
                    {
                      directives: [
                        {
                          name: "b-tooltip",
                          rawName: "v-b-tooltip.hover",
                          value: _vm.$t(
                            "apeironGwApp.legajo.acciones.verHistorico"
                          ),
                          expression:
                            "$t('apeironGwApp.legajo.acciones.verHistorico')",
                          modifiers: { hover: true },
                        },
                      ],
                      attrs: { variant: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.mostrarModal()
                        },
                      },
                    },
                    [
                      _c("b-icon-x-diamond-fill"),
                      _vm._v(" "),
                      _vm.mostrarTextoEnBoton
                        ? _c("span", {
                            domProps: {
                              textContent: _vm._s(
                                _vm.$t(
                                  "apeironGwApp.legajo.acciones.verHistorico"
                                )
                              ),
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c(
                "b-col",
                [
                  _c(
                    "b-modal",
                    {
                      attrs: {
                        id: "modal-legajos",
                        size: "xl",
                        scrollable: "",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "modal-title",
                          fn: function () {
                            return [
                              _c("span", {
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.$t(
                                      "apeironGwApp.legajo.mensajes.titulo"
                                    )
                                  ),
                                },
                              }),
                            ]
                          },
                          proxy: true,
                        },
                        {
                          key: "modal-footer",
                          fn: function () {
                            return [
                              _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    { staticClass: "text-right" },
                                    [
                                      _c(
                                        "b-button",
                                        {
                                          attrs: { variant: "secondary" },
                                          on: {
                                            click: function ($event) {
                                              _vm.modalVisible = false
                                            },
                                          },
                                        },
                                        [
                                          _c("span", {
                                            domProps: {
                                              textContent: _vm._s(
                                                _vm.$t(
                                                  "apeironGwApp.legajo.acciones.cerrar"
                                                )
                                              ),
                                            },
                                          }),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ]),
                      model: {
                        value: _vm.modalVisible,
                        callback: function ($$v) {
                          _vm.modalVisible = $$v
                        },
                        expression: "modalVisible",
                      },
                    },
                    [
                      _vm._v(" "),
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            [
                              _c(
                                "b-overlay",
                                { attrs: { show: _vm.consultandoElBack } },
                                [
                                  _c(
                                    "b-row",
                                    [
                                      _vm.opcionesEntidades.length > 1
                                        ? _c(
                                            "b-col",
                                            { attrs: { cols: "6" } },
                                            [
                                              _c(
                                                "b-form-group",
                                                {
                                                  attrs: {
                                                    label: _vm.$t(
                                                      "apeironGwApp.legajo.campos.entidadLegajo"
                                                    ),
                                                    "label-for":
                                                      "filtro-entidad",
                                                  },
                                                },
                                                [
                                                  _c("b-form-select", {
                                                    staticClass:
                                                      "resaltar-opciones-disabled",
                                                    attrs: {
                                                      name: "filtro-entidad",
                                                      options:
                                                        _vm.opcionesEntidades,
                                                    },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "first",
                                                          fn: function () {
                                                            return [
                                                              _c(
                                                                "b-form-select-option",
                                                                {
                                                                  attrs: {
                                                                    value:
                                                                      undefined,
                                                                  },
                                                                },
                                                                [
                                                                  _c("span", {
                                                                    domProps: {
                                                                      textContent:
                                                                        _vm._s(
                                                                          _vm.$t(
                                                                            "apeironGwApp.legajo.mensajes.seleccionarTodos"
                                                                          )
                                                                        ),
                                                                    },
                                                                  }),
                                                                ]
                                                              ),
                                                            ]
                                                          },
                                                          proxy: true,
                                                        },
                                                      ],
                                                      null,
                                                      false,
                                                      2505838654
                                                    ),
                                                    model: {
                                                      value:
                                                        _vm.filtroLegajo
                                                          .entidadLegajo,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.filtroLegajo,
                                                          "entidadLegajo",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "filtroLegajo.entidadLegajo",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.opcionesEventos.length > 1
                                        ? _c(
                                            "b-col",
                                            { attrs: { cols: "6" } },
                                            [
                                              _c(
                                                "b-form-group",
                                                {
                                                  attrs: {
                                                    label: _vm.$t(
                                                      "apeironGwApp.legajo.campos.eventoLegajo"
                                                    ),
                                                    "label-for":
                                                      "filtro-evento",
                                                  },
                                                },
                                                [
                                                  _c("b-form-select", {
                                                    staticClass:
                                                      "resaltar-opciones-disabled",
                                                    attrs: {
                                                      name: "filtro-evento",
                                                      options:
                                                        _vm.opcionesEventos,
                                                    },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "first",
                                                          fn: function () {
                                                            return [
                                                              _c(
                                                                "b-form-select-option",
                                                                {
                                                                  attrs: {
                                                                    value:
                                                                      undefined,
                                                                  },
                                                                },
                                                                [
                                                                  _c("span", {
                                                                    domProps: {
                                                                      textContent:
                                                                        _vm._s(
                                                                          _vm.$t(
                                                                            "apeironGwApp.legajo.mensajes.seleccionarTodos"
                                                                          )
                                                                        ),
                                                                    },
                                                                  }),
                                                                ]
                                                              ),
                                                            ]
                                                          },
                                                          proxy: true,
                                                        },
                                                      ],
                                                      null,
                                                      false,
                                                      2505838654
                                                    ),
                                                    model: {
                                                      value:
                                                        _vm.filtroLegajo
                                                          .eventoLegajo,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.filtroLegajo,
                                                          "eventoLegajo",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "filtroLegajo.eventoLegajo",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "b-col",
                                        { attrs: { cols: "6" } },
                                        [
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                label: _vm.$t(
                                                  "apeironGwApp.legajo.campos.fechaInicio"
                                                ),
                                                "label-for":
                                                  "filtro-fecha-inicio",
                                              },
                                            },
                                            [
                                              _c("b-form-datepicker", {
                                                attrs: {
                                                  name: "filtro-fecha-inicio",
                                                  placeholder: _vm.$t(
                                                    "apeironGwApp.legajo.campos.fechaInicio"
                                                  ),
                                                  max: _vm.filtroLegajo
                                                    .fechaFin,
                                                  locale: "es",
                                                  "value-as-date": true,
                                                },
                                                model: {
                                                  value:
                                                    _vm.filtroLegajo
                                                      .fechaInicio,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.filtroLegajo,
                                                      "fechaInicio",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "filtroLegajo.fechaInicio",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-col",
                                        { attrs: { cols: "6" } },
                                        [
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                label: _vm.$t(
                                                  "apeironGwApp.legajo.campos.fechaFin"
                                                ),
                                                "label-for": "filtro-fecha-fin",
                                              },
                                            },
                                            [
                                              _c("b-form-datepicker", {
                                                attrs: {
                                                  name: "filtro-fecha-fin",
                                                  placeholder: _vm.$t(
                                                    "apeironGwApp.legajo.campos.fechaFin"
                                                  ),
                                                  min: _vm.filtroLegajo
                                                    .fechaInicio,
                                                  locale: "es",
                                                  "value-as-date": true,
                                                },
                                                model: {
                                                  value:
                                                    _vm.filtroLegajo.fechaFin,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.filtroLegajo,
                                                      "fechaFin",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "filtroLegajo.fechaFin",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      !_vm.participacionId
                                        ? _c(
                                            "b-col",
                                            { attrs: { cols: "6" } },
                                            [
                                              _c(
                                                "b-form-group",
                                                {
                                                  attrs: {
                                                    label: _vm.$t(
                                                      "apeironGwApp.legajo.campos.tag"
                                                    ),
                                                    "label-for": "filtro-tag",
                                                  },
                                                },
                                                [
                                                  _c("b-form-input", {
                                                    attrs: {
                                                      name: "filtro-tag",
                                                      placeholder: _vm.$t(
                                                        "apeironGwApp.legajo.mensajes.tagPlaceholder"
                                                      ),
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.filtroLegajo.tag,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.filtroLegajo,
                                                          "tag",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "filtroLegajo.tag",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "b-col",
                                        {
                                          staticClass: "text-right mt-5",
                                          attrs: { cols: "6" },
                                        },
                                        [
                                          _c(
                                            "b-button",
                                            {
                                              attrs: { variant: "outline" },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.iniciarComponente()
                                                },
                                              },
                                            },
                                            [
                                              _c("b-icon-eraser"),
                                              _vm._v(" "),
                                              _c("span", {
                                                domProps: {
                                                  textContent: _vm._s(
                                                    _vm.$t(
                                                      "apeironGwApp.legajo.acciones.limpiar"
                                                    )
                                                  ),
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-button",
                                            {
                                              attrs: { variant: "primary" },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.buscarDesdePrimerPagina()
                                                },
                                              },
                                            },
                                            [
                                              _c("b-icon-search"),
                                              _vm._v(" "),
                                              _c("span", {
                                                domProps: {
                                                  textContent: _vm._s(
                                                    _vm.$t(
                                                      "apeironGwApp.legajo.acciones.buscar"
                                                    )
                                                  ),
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-row",
                                    { staticClass: "mt-2" },
                                    [
                                      _c(
                                        "b-col",
                                        {
                                          staticClass:
                                            "area-responsive area-responsive-tabla",
                                        },
                                        [
                                          _c("b-table", {
                                            attrs: {
                                              striped: "",
                                              hover: "",
                                              bordered: "",
                                              small: "",
                                              "thead-class": "custom-header",
                                              items: _vm.legajos,
                                              fields: _vm.fieldsLegajo,
                                              "show-empty": "",
                                              "empty-text": _vm.$t(
                                                "apeironGwApp.legajo.mensajes.sinRegistros"
                                              ),
                                            },
                                            scopedSlots: _vm._u([
                                              {
                                                key: "cell(entidadLegajo)",
                                                fn: function (data) {
                                                  return [
                                                    _c("span", {
                                                      class: [
                                                        _vm.legajoSeleccionado
                                                          .id != data.item.id
                                                          ? ""
                                                          : "text-primary",
                                                      ],
                                                      domProps: {
                                                        textContent: _vm._s(
                                                          _vm.$t(
                                                            `apeironGwApp.legajo.entidades.${data.item.entidadLegajo}`
                                                          )
                                                        ),
                                                      },
                                                    }),
                                                  ]
                                                },
                                              },
                                              {
                                                key: "cell(eventoLegajo)",
                                                fn: function (data) {
                                                  return [
                                                    _c("span", {
                                                      domProps: {
                                                        textContent: _vm._s(
                                                          _vm.$t(
                                                            `apeironGwApp.legajo.eventos.${data.item.eventoLegajo}`
                                                          )
                                                        ),
                                                      },
                                                    }),
                                                  ]
                                                },
                                              },
                                              {
                                                key: "cell(acciones)",
                                                fn: function (data) {
                                                  return [
                                                    _c(
                                                      "b-button",
                                                      {
                                                        directives: [
                                                          {
                                                            name: "b-tooltip",
                                                            rawName:
                                                              "v-b-tooltip.hover.left",
                                                            value: _vm.$t(
                                                              "apeironGwApp.legajo.acciones.verDatos"
                                                            ),
                                                            expression:
                                                              "$t('apeironGwApp.legajo.acciones.verDatos')",
                                                            modifiers: {
                                                              hover: true,
                                                              left: true,
                                                            },
                                                          },
                                                        ],
                                                        attrs: {
                                                          variant:
                                                            _vm
                                                              .legajoSeleccionado
                                                              .id !=
                                                            data.item.id
                                                              ? "outline"
                                                              : "primary",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.seleccionarLegajo(
                                                              data.item
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _c("b-icon", {
                                                          attrs: {
                                                            icon: "chevron-double-down",
                                                            variant:
                                                              _vm
                                                                .legajoSeleccionado
                                                                .id !=
                                                              data.item.id
                                                                ? "secondary"
                                                                : "success",
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                },
                                              },
                                            ]),
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-row",
                                    { staticClass: "mt-4" },
                                    [
                                      _c(
                                        "b-col",
                                        { attrs: { md: "4" } },
                                        [
                                          _c(
                                            "b-row",
                                            [
                                              _c(
                                                "b-col",
                                                { attrs: { md: "4" } },
                                                [
                                                  _c("b-form-select", {
                                                    attrs: {
                                                      size: "sm",
                                                      id: "per-page-select",
                                                      options: _vm.pageOptions,
                                                    },
                                                    on: {
                                                      change:
                                                        _vm.buscarDesdePrimerPagina,
                                                    },
                                                    model: {
                                                      value: _vm.perPage,
                                                      callback: function ($$v) {
                                                        _vm.perPage = $$v
                                                      },
                                                      expression: "perPage",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "b-col",
                                                {
                                                  staticClass: "pie-tabla mt-1",
                                                  attrs: { md: "8" },
                                                },
                                                [
                                                  _c("span", {
                                                    domProps: {
                                                      textContent: _vm._s(
                                                        _vm.$t(
                                                          "apeironGwApp.legajo.mensajes.registrosPorPagina"
                                                        )
                                                      ),
                                                    },
                                                  }),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-col",
                                        { attrs: { md: "4" } },
                                        [
                                          _c("b-pagination", {
                                            attrs: {
                                              size: "sm",
                                              "total-rows": _vm.registros,
                                              "per-page": _vm.perPage,
                                              align: "fill",
                                              pills: "",
                                            },
                                            on: { change: _vm.cambiarPagina },
                                            model: {
                                              value: _vm.currentPage,
                                              callback: function ($$v) {
                                                _vm.currentPage = $$v
                                              },
                                              expression: "currentPage",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-col",
                                        {
                                          staticClass:
                                            "text-right pie-tabla mt-1",
                                          attrs: { md: "4" },
                                        },
                                        [
                                          _c("span", {
                                            domProps: {
                                              textContent: _vm._s(
                                                _vm.registros
                                              ),
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c("span", {
                                            staticClass: "ml-1",
                                            domProps: {
                                              textContent: _vm._s(
                                                _vm.$t(
                                                  "apeironGwApp.legajo.mensajes.totalDeRegistros"
                                                )
                                              ),
                                            },
                                          }),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  !!_vm.legajoSeleccionado.id
                                    ? _c(
                                        "b-row",
                                        [
                                          _c(
                                            "b-col",
                                            [
                                              _c("hr", {
                                                staticClass:
                                                  "linea-horizontal-roja",
                                              }),
                                              _vm._v(" "),
                                              _c("detalle-legajo", {
                                                attrs: {
                                                  legajo:
                                                    _vm.legajoSeleccionado,
                                                },
                                                on: {
                                                  detallesOcultos: function (
                                                    $event
                                                  ) {
                                                    return _vm.manejaOcultarDetalles()
                                                  },
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }